var React = require('react');

function LuggageStorageInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"17","y":"15","width":"30","height":"37","rx":"4","key":0}),React.createElement("circle",{"cx":"24.5","cy":"54.5","r":"2.5","key":1}),React.createElement("circle",{"cx":"39.5","cy":"54.5","r":"2.5","key":2}),React.createElement("path",{"d":"M23 21h18m-14 9v13m10-13v13M30 5v7","key":3}),React.createElement("rect",{"x":"25","y":"1","width":"14","height":"4","rx":"2","key":4}),React.createElement("path",{"d":"M34 5v7m25 25v18a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V37","key":5})]));
}

LuggageStorageInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = LuggageStorageInline;

LuggageStorageInline.default = LuggageStorageInline;
